import { render, staticRenderFns } from "./SendInvitationLink.vue?vue&type=template&id=150f099a&scoped=true&"
import script from "./SendInvitationLink.vue?vue&type=script&lang=js&"
export * from "./SendInvitationLink.vue?vue&type=script&lang=js&"
import style0 from "./SendInvitationLink.vue?vue&type=style&index=0&id=150f099a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f099a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150f099a')) {
      api.createRecord('150f099a', component.options)
    } else {
      api.reload('150f099a', component.options)
    }
    module.hot.accept("./SendInvitationLink.vue?vue&type=template&id=150f099a&scoped=true&", function () {
      api.rerender('150f099a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/SendInvitationLink.vue"
export default component.exports